/* Sammy's Catering Co. — package menu data.
   Transcribed from the client's Package Breakdown PDF via the approved prototype.
   Shape: sets{} holds the pickable option lists; each tier lists components, and a
   component with a `set` becomes its own step with a choose-N rule.
   To add or edit a package, edit this file only — no markup changes needed. */
window.SAMMYS_MENUS = {
 "corporate-breakfast": {
  "name": "Corporate Breakfast",
  "meta": [
   "Minimum 10 guests",
   "Drop off",
   "Start the day the Lebanese way"
  ],
  "minGuests": 10,
  "minOrder": 300,
  "footnote": "Live Lebanese breakfast stations also available for larger events.",
  "sets": {
   "bagel": {
    "title": "Bagel & croissant fillings",
    "carrier": {
     "label": "Served on",
     "options": ["Bagel", "Croissant"]
    },
    "options": [
     {
      "name": "Zataar, cucumber, tomato & olives",
      "diet": "vegan v"
     },
     {
      "name": "Haloumi",
      "diet": "v"
     },
     {
      "name": "Turkey, avocado, tomato, cheese & honey mustard"
     },
     {
      "name": "Zataar, turkey breast & cheese"
     },
     {
      "name": "Bocconcini, cherry tomato, avocado & pesto",
      "diet": "v"
     },
     {
      "name": "Bastarma, cheese, dijon & lettuce"
     },
     {
      "name": "Ricotta & honey"
     },
     {
      "name": "Smoked salmon"
     }
    ]
   },
   "sweet": {
    "title": "Sweet & fresh",
    "options": [
     {
      "name": "Mini flavoured croissants"
     },
     {
      "name": "Mini fruit danish"
     },
     {
      "name": "Scones with cream & jam"
     },
     {
      "name": "Friands",
      "diet": "gf"
     },
     {
      "name": "Gourmet muffins",
      "sub": "GF & vegan available",
      "diet": "gf vegan v"
     },
     {
      "name": "Fruit salad cups"
     },
     {
      "name": "Yoghurt granola cups"
     },
     {
      "name": "Whole fruit bowl"
     }
    ]
   },
   "warm": {
    "title": "Warm & loaded bites",
    "options": [
     {
      "name": "Gourmet sausage rolls: lamb & rosemary"
     },
     {
      "name": "Gourmet sausage rolls: honey mustard chicken"
     },
     {
      "name": "Gourmet sausage rolls: cheese & spinach",
      "diet": "v"
     },
     {
      "name": "Mini quiches"
     },
     {
      "name": "Falafel pockets",
      "diet": "v"
     },
     {
      "name": "Spinach fatayer",
      "diet": "vegan v"
     },
     {
      "name": "Loaded bites: ricotta & honey"
     },
     {
      "name": "Loaded bites: avocado & feta"
     },
     {
      "name": "Loaded bites: shangleesh"
     },
     {
      "name": "Loaded bites: turkey cranberry & brie"
     }
    ]
   },
   "manouche": {
    "title": "Manouche",
    "suggested": true,
    "note": "Served warm, cut into wedges",
    "options": [
     {
      "name": "Zaatar",
      "diet": "vegan v"
     },
     {
      "name": "Cheese",
      "diet": "v"
     },
     {
      "name": "Zaatar & cheese",
      "diet": "v"
     },
     {
      "name": "Spinach & sumac",
      "diet": "vegan v"
     },
     {
      "name": "Lahm bi ajin, spiced meat"
     },
     {
      "name": "Cheese & sujuk"
     },
     {
      "name": "Labneh, tomato & mint",
      "diet": "v"
     }
    ]
   },
   "sandwiches": {
    "title": "Fresh sandwiches",
    "note": "On panini, wraps or Lebanese flatbread",
    "options": [
     {
      "name": "BBQ chicken"
     },
     {
      "name": "Shawarma chicken"
     },
     {
      "name": "Kafta"
     },
     {
      "name": "Roasted vegetable",
      "diet": "v"
     },
     {
      "name": "Falafel",
      "diet": "v"
     },
     {
      "name": "Cold meats"
     }
    ]
   }
  },
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 16,
    "includes": "Filled bagels and mini croissants · Mini pastries · Seasonal fruit salad cups",
    "components": [
     {
      "name": "Filled bagels and mini croissants",
      "qty": "1 per person",
      "set": "bagel",
      "choose": 3
     },
     {
      "name": "Mini pastries",
      "qty": "1 per person",
      "set": "sweet",
      "choose": 2
     },
     {
      "name": "Seasonal fruit salad cups",
      "qty": "1 per person"
     },
     {
      "name": "Disposable serveware",
      "qty": "Included"
     }
    ],
    "variantId": 49073359814888
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 22,
    "includes": "Full Mezza Package Included · Filled bagels and mini croissants · Mini pastries · Seasonal fruit salad cups · Gourmet sausage rolls · Mini quiches · Yoghurt granola cups",
    "components": [
     {
      "group": "Full Mezza package included"
     },
     {
      "name": "Filled bagels and mini croissants",
      "qty": "1 per person",
      "set": "bagel",
      "choose": 4
     },
     {
      "name": "Mini pastries",
      "qty": "1 per person",
      "set": "sweet",
      "choose": 2
     },
     {
      "name": "Seasonal fruit salad cups",
      "qty": "1 per person"
     },
     {
      "group": "Plus"
     },
     {
      "name": "Gourmet sausage rolls",
      "qty": "1 per person",
      "set": "warm",
      "choose": 2
     },
     {
      "name": "Mini quiches",
      "qty": "1 per person"
     },
     {
      "name": "Yoghurt granola cups",
      "qty": "1 per 2 guests"
     }
    ],
    "variantId": 49073359847656
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 28,
    "includes": "Filled bagels and mini croissants · Manouche, cut into wedges · Falafel pockets · Loaded bites · Fresh sandwiches, halved · Knafeh cups",
    "components": [
     {
      "name": "Filled bagels and mini croissants",
      "qty": "1 per person",
      "set": "bagel",
      "choose": 4
     },
     {
      "name": "Manouche, cut into wedges",
      "qty": "2 wedges per person",
      "set": "manouche",
      "choose": 2
     },
     {
      "name": "Falafel pockets",
      "qty": "1 per person"
     },
     {
      "name": "Loaded bites",
      "qty": "1 per person",
      "set": "warm",
      "choose": 2
     },
     {
      "name": "Fresh sandwiches, halved",
      "qty": "1 half per person",
      "set": "sandwiches",
      "choose": 2
     },
     {
      "name": "Knafeh cups",
      "qty": "1 per person"
     }
    ],
    "variantId": 49073359880424
   }
  ],
  "slug": "corporate-breakfast"
 },
 "morning-afternoon-tea": {
  "name": "Morning & Afternoon Tea",
  "meta": [
   "Minimum 10 guests",
   "Drop off",
   "For meetings, training days and office celebrations"
  ],
  "minGuests": 10,
  "minOrder": 300,
  "footnote": "Gluten free and vegan selections available across all tiers.",
  "sets": {
   "pastries": {
    "title": "Sweet pastries",
    "note": "All cocktail size",
    "options": [
     {
      "name": "Flavoured croissants"
     },
     {
      "name": "Fruit danish"
     },
     {
      "name": "Scones with cream & jam"
     },
     {
      "name": "Friands",
      "diet": "gf"
     },
     {
      "name": "Gourmet muffins",
      "sub": "GF & vegan available",
      "diet": "gf vegan v"
     },
     {
      "name": "Viral Dubai croissant"
     }
    ]
   },
   "cakes": {
    "title": "Cakes & slices",
    "options": [
     {
      "name": "Chocolate hedgehog"
     },
     {
      "name": "Brownies"
     },
     {
      "name": "Loaded brownies"
     },
     {
      "name": "Loaded cupcakes"
     },
     {
      "name": "Buffet cake slice: chocolate mud"
     },
     {
      "name": "Buffet cake slice: apple crumble"
     },
     {
      "name": "Buffet cake slice: carrot"
     },
     {
      "name": "Buffet cake slice: tiramisu"
     }
    ]
   },
   "bites": {
    "title": "Bites & cups",
    "note": "All cocktail size",
    "options": [
     {
      "name": "Cannoli"
     },
     {
      "name": "Knafeh cups"
     },
     {
      "name": "Rice pudding cups"
     },
     {
      "name": "Fruit custard tarts"
     },
     {
      "name": "Cheesecakes"
     },
     {
      "name": "Eclairs"
     },
     {
      "name": "Katayfi fingers"
     },
     {
      "name": "Chocolate sombosik"
     }
    ]
   },
   "savoury": {
    "title": "Savoury & fresh",
    "note": "All cocktail size",
    "options": [
     {
      "name": "Quiches"
     },
     {
      "name": "Savoury muffins"
     },
     {
      "name": "Gourmet sausage rolls"
     },
     {
      "name": "Loaded bites: ricotta, honey, grilled pear & walnut",
      "diet": "v"
     },
     {
      "name": "Loaded bites: garlic avocado, feta, walnut & pomegranate",
      "diet": "v"
     },
     {
      "name": "Loaded bites: marinated shangleesh, tomato & red onion",
      "diet": "v"
     },
     {
      "name": "Loaded bites: turkey, cranberry & brie"
     },
     {
      "name": "Pizzas"
     },
     {
      "name": "Fruit salad cups",
      "diet": "vegan v"
     },
     {
      "name": "Yoghurt granola cups",
      "diet": "v"
     },
     {
      "name": "Seasonal fruit platter",
      "diet": "vegan v"
     },
     {
      "name": "Whole fruit bowl",
      "diet": "vegan v"
     }
    ]
   }
  },
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 14,
    "includes": "Pastries · Fresh fruit salad cups",
    "components": [
     {
      "name": "Pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 2
     },
     {
      "name": "Fresh fruit salad cups",
      "qty": "1 per person"
     },
     {
      "name": "Disposable serveware",
      "qty": "Included"
     }
    ],
    "variantId": 49073360077032
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 18,
    "includes": "Full Mezza Package Included · Pastries · Fresh fruit salad cups · Gourmet muffins · Yoghurt granola cups",
    "components": [
     {
      "group": "Full Mezza package included"
     },
     {
      "name": "Pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 3
     },
     {
      "name": "Fresh fruit salad cups",
      "qty": "1 per person"
     },
     {
      "group": "Plus"
     },
     {
      "name": "Gourmet muffins",
      "qty": "1 per person"
     },
     {
      "name": "Yoghurt granola cups",
      "qty": "1 per 2 guests"
     }
    ],
    "variantId": 49073360109800
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 26,
    "includes": "Full Ahla Package Included · Pastries · Cakes and slices · Bites and cups · Savoury items",
    "components": [
     {
      "group": "Full Ahla package included"
     },
     {
      "name": "Pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 3
     },
     {
      "group": "Plus"
     },
     {
      "name": "Cakes and slices",
      "qty": "1 per person",
      "set": "cakes",
      "choose": 2
     },
     {
      "name": "Bites and cups",
      "qty": "1 per person",
      "set": "bites",
      "choose": 2
     },
     {
      "name": "Savoury items",
      "qty": "1 per person",
      "set": "savoury",
      "choose": 2
     }
    ],
    "variantId": 49073360142568
   }
  ],
  "slug": "morning-afternoon-tea"
 },
 "working-lunch": {
  "name": "Working Lunch",
  "meta": [
   "Minimum 10 guests",
   "Drop off",
   "Feed the team well without leaving the office"
  ],
  "minGuests": 10,
  "minOrder": 300,
  "footnote": "One in four sandwiches is vegetarian as standard, adjusted to your numbers on request, and every dietary portion is packed and labelled separately. Build Your Own Platter menu also available.",
  "sets": {
   "fillings": {
    "title": "Sandwich fillings",
    "options": [
     {
      "name": "BBQ chicken"
     },
     {
      "name": "Shawarma meat"
     },
     {
      "name": "Shawarma chicken"
     },
     {
      "name": "Kafta"
     },
     {
      "name": "Chicken schnitzel"
     },
     {
      "name": "Roasted vegetable",
      "diet": "v"
     },
     {
      "name": "Falafel",
      "diet": "v"
     },
     {
      "name": "Fried cauliflower",
      "diet": "v"
     },
     {
      "name": "Cold meats"
     }
    ]
   },
   "breads": {
    "title": "Breads",
    "note": "Gluten free sandwich adds $3.50 per serve",
    "options": [
     {
      "name": "Panini"
     },
     {
      "name": "Wraps"
     },
     {
      "name": "Finger sandwiches"
     },
     {
      "name": "Lebanese flatbread"
     },
     {
      "name": "Focaccia"
     },
     {
      "name": "Gluten free sandwich",
      "sub": "Adds $3.50 per serve",
      "diet": "gf"
     }
    ]
   },
   "salads": {
    "title": "Salads",
    "options": [
     {
      "name": "Tabouli",
      "sub": "Vegan, DF",
      "diet": "vegan v"
     },
     {
      "name": "Fattoush",
      "sub": "Vegan, DF, GF available",
      "diet": "vegan v gf"
     },
     {
      "name": "Greek",
      "diet": "v"
     },
     {
      "name": "Rainbow cabbage slaw",
      "diet": "v"
     },
     {
      "name": "Roasted pumpkin & couscous",
      "diet": "v"
     },
     {
      "name": "Potato",
      "diet": "v"
     },
     {
      "name": "Pasta",
      "diet": "v"
     },
     {
      "name": "Caesar"
     }
    ]
   },
   "dips": {
    "title": "Dips",
    "options": [
     {
      "name": "Hommous",
      "diet": "vegan v"
     },
     {
      "name": "Baba ghanouj",
      "diet": "vegan v"
     },
     {
      "name": "Labneh",
      "diet": "v"
     },
     {
      "name": "Garlic",
      "diet": "vegan v"
     },
     {
      "name": "Shangleesh",
      "diet": "v"
     },
     {
      "name": "Avocado & garlic",
      "diet": "vegan v"
     }
    ]
   },
   "mains": {
    "title": "Hot mains",
    "note": "Sahtein tier only",
    "options": [
     {
      "name": "Chicken lemon garlic"
     },
     {
      "name": "Kafta & potato"
     },
     {
      "name": "Beef lasagne"
     },
     {
      "name": "Shepherds pie"
     },
     {
      "name": "Chicken breast in creamy mushroom sauce"
     },
     {
      "name": "Mjadra",
      "diet": "vegan v"
     },
     {
      "name": "Creamy vegetarian pesto rigatoni pasta",
      "diet": "v"
     },
     {
      "name": "Loubiyeh and rice"
     },
     {
      "name": "Steak with mushroom sauce"
     }
    ]
   },
   "rice": {
    "title": "Rice",
    "options": [
     {
      "name": "Chicken mansaf",
      "diet": "gf"
     },
     {
      "name": "Lamb mansaf",
      "diet": "gf"
     },
     {
      "name": "Persian jewelled rice",
      "diet": "gf"
     },
     {
      "name": "Saffron yellow rice",
      "diet": "gf vegan v"
     },
     {
      "name": "Vermicelli noodle rice",
      "diet": "vegan v"
     },
     {
      "name": "Chicken and rice"
     },
     {
      "name": "Plain rice with egg noodle"
     }
    ]
   },
   "bites": {
    "title": "Bites & cups",
    "options": [
     {
      "name": "Mini cannoli"
     },
     {
      "name": "Knafeh cups"
     },
     {
      "name": "Rice pudding cups"
     },
     {
      "name": "Fruit custard tarts"
     },
     {
      "name": "Mini cheesecakes"
     },
     {
      "name": "Mini eclairs"
     },
     {
      "name": "Katayfi fingers"
     },
     {
      "name": "Chocolate sombosik"
     }
    ]
   }
  },
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 26,
    "includes": "Gourmet sandwiches · Bread · Fresh salad, large tray · Seasonal fruit platter",
    "components": [
     {
      "name": "Gourmet sandwiches",
      "qty": "1.5 rounds per person",
      "set": "fillings",
      "choose": 3
     },
     {
      "name": "Bread",
      "qty": "As selected",
      "set": "breads",
      "choose": 1,
      "chooseMax": 5
     },
     {
      "name": "Fresh salad, large tray",
      "qty": "1 tray per 20 guests",
      "set": "salads",
      "choose": 1
     },
     {
      "name": "Seasonal fruit platter",
      "qty": "1 per 20 guests"
     }
    ],
    "variantId": 49073360175336
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 32,
    "includes": "Full Mezza Package Included · Gourmet sandwiches · Bread · Seasonal fruit platter · Fresh salads, large tray · Home made dips with Lebanese bread and pickles · Falafel with tahini",
    "components": [
     {
      "group": "Full Mezza package included"
     },
     {
      "name": "Gourmet sandwiches",
      "qty": "1.5 rounds per person",
      "set": "fillings",
      "choose": 3
     },
     {
      "name": "Bread",
      "qty": "As selected",
      "set": "breads",
      "choose": 1,
      "chooseMax": 5
     },
     {
      "name": "Seasonal fruit platter",
      "qty": "1 per 20 guests"
     },
     {
      "group": "Plus"
     },
     {
      "name": "Fresh salads, large tray",
      "qty": "2 trays per 20 guests",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Home made dips with Lebanese bread and pickles",
      "qty": "1 platter per 20 guests",
      "set": "dips",
      "choose": 3
     },
     {
      "name": "Falafel with tahini",
      "qty": "2 pieces per person"
     }
    ],
    "variantId": 49073360208104
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 45,
    "includes": "Hot main, large tray · Rice, large tray · Fresh salads, large tray · Home made dips with Lebanese bread and pickles · Dessert selection",
    "components": [
     {
      "name": "Hot main, large tray",
      "qty": "1 tray per 15 guests",
      "set": "mains",
      "choose": 1
     },
     {
      "name": "Rice, large tray",
      "qty": "1 tray per 18 guests",
      "set": "rice",
      "choose": 1
     },
     {
      "name": "Fresh salads, large tray",
      "qty": "2 trays per 20 guests",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Home made dips with Lebanese bread and pickles",
      "qty": "1 platter per 20 guests",
      "set": "dips",
      "choose": 3
     },
     {
      "name": "Dessert selection",
      "qty": "1 piece per person",
      "set": "bites",
      "choose": 2
     }
    ],
    "variantId": 49073360240872
   }
  ],
  "slug": "working-lunch"
 },
 "full-day-meetings": {
  "name": "Full Day Meetings",
  "meta": [
   "Minimum 10 guests",
   "Drop off",
   "Morning tea, lunch and afternoon tea in one booking"
  ],
  "minGuests": 10,
  "minOrder": 300,
  "footnote": "Timed deliveries arranged to suit your agenda. Ideal for conferences, training days and offsites.",
  "sets": {
   "pastries": {
    "title": "Sweet pastries",
    "options": [
     {
      "name": "Mini flavoured croissants"
     },
     {
      "name": "Mini fruit danish"
     },
     {
      "name": "Scones with cream & jam"
     },
     {
      "name": "Friands",
      "diet": "gf"
     },
     {
      "name": "Gourmet muffins",
      "sub": "GF & vegan available",
      "diet": "gf vegan v"
     },
     {
      "name": "Viral Dubai mini croissant"
     }
    ]
   },
   "cakes": {
    "title": "Cakes & slices",
    "options": [
     {
      "name": "Chocolate hedgehog"
     },
     {
      "name": "Brownies"
     },
     {
      "name": "Loaded brownies"
     },
     {
      "name": "Loaded cupcakes"
     },
     {
      "name": "Buffet cake slice: chocolate mud"
     },
     {
      "name": "Buffet cake slice: apple crumble"
     },
     {
      "name": "Buffet cake slice: carrot"
     },
     {
      "name": "Buffet cake slice: tiramisu"
     }
    ]
   },
   "bites": {
    "title": "Bites & cups",
    "options": [
     {
      "name": "Mini cannoli"
     },
     {
      "name": "Knafeh cups"
     },
     {
      "name": "Rice pudding cups"
     },
     {
      "name": "Fruit custard tarts"
     },
     {
      "name": "Mini cheesecakes"
     },
     {
      "name": "Mini eclairs"
     },
     {
      "name": "Katayfi fingers"
     },
     {
      "name": "Chocolate sombosik"
     }
    ]
   },
   "savoury": {
    "title": "Savoury & fresh",
    "options": [
     {
      "name": "Mini quiches"
     },
     {
      "name": "Savoury muffins"
     },
     {
      "name": "Gourmet sausage rolls"
     },
     {
      "name": "Loaded bites: ricotta, honey, grilled pear & walnut",
      "diet": "v"
     },
     {
      "name": "Loaded bites: garlic avocado, feta, walnut & pomegranate",
      "diet": "v"
     },
     {
      "name": "Loaded bites: marinated shangleesh, tomato & red onion",
      "diet": "v"
     },
     {
      "name": "Loaded bites: turkey, cranberry & brie"
     },
     {
      "name": "Mini pizzas"
     },
     {
      "name": "Fruit salad cups",
      "diet": "vegan v"
     },
     {
      "name": "Yoghurt granola cups",
      "diet": "v"
     },
     {
      "name": "Seasonal fruit platter",
      "diet": "vegan v"
     },
     {
      "name": "Whole fruit bowl",
      "diet": "vegan v"
     }
    ]
   },
   "fillings": {
    "title": "Sandwich fillings",
    "options": [
     {
      "name": "BBQ chicken"
     },
     {
      "name": "Shawarma meat"
     },
     {
      "name": "Shawarma chicken"
     },
     {
      "name": "Kafta"
     },
     {
      "name": "Chicken schnitzel"
     },
     {
      "name": "Roasted vegetable",
      "diet": "v"
     },
     {
      "name": "Falafel",
      "diet": "v"
     },
     {
      "name": "Fried cauliflower",
      "diet": "v"
     },
     {
      "name": "Cold meats"
     }
    ]
   },
   "breads": {
    "title": "Breads",
    "note": "Gluten free sandwich adds $3.50 per serve",
    "options": [
     {
      "name": "Panini"
     },
     {
      "name": "Wraps"
     },
     {
      "name": "Finger sandwiches"
     },
     {
      "name": "Lebanese flatbread"
     },
     {
      "name": "Focaccia"
     },
     {
      "name": "Gluten free sandwich",
      "sub": "Adds $3.50 per serve",
      "diet": "gf"
     }
    ]
   },
   "salads": {
    "title": "Salads",
    "options": [
     {
      "name": "Tabouli",
      "sub": "Vegan, DF",
      "diet": "vegan v"
     },
     {
      "name": "Fattoush",
      "sub": "Vegan, DF, GF available",
      "diet": "vegan v gf"
     },
     {
      "name": "Greek",
      "diet": "v"
     },
     {
      "name": "Rainbow cabbage slaw",
      "diet": "v"
     },
     {
      "name": "Roasted pumpkin & couscous",
      "diet": "v"
     },
     {
      "name": "Potato",
      "diet": "v"
     },
     {
      "name": "Pasta",
      "diet": "v"
     },
     {
      "name": "Caesar"
     }
    ]
   },
   "dips": {
    "title": "Dips",
    "options": [
     {
      "name": "Hommous",
      "diet": "vegan v"
     },
     {
      "name": "Baba ghanouj",
      "diet": "vegan v"
     },
     {
      "name": "Labneh",
      "diet": "v"
     },
     {
      "name": "Garlic",
      "diet": "vegan v"
     },
     {
      "name": "Shangleesh",
      "diet": "v"
     },
     {
      "name": "Avocado & garlic",
      "diet": "vegan v"
     }
    ]
   },
   "hotMains": {
    "title": "Hot mains",
    "note": "Sahtein tier only",
    "options": [
     {
      "name": "Chicken lemon garlic"
     },
     {
      "name": "Kafta & potato"
     },
     {
      "name": "Beef lasagne"
     },
     {
      "name": "Shepherds pie"
     },
     {
      "name": "Chicken breast in creamy mushroom sauce"
     },
     {
      "name": "Mjadra",
      "diet": "vegan v"
     }
    ]
   },
   "rice": {
    "title": "Rice",
    "options": [
     {
      "name": "Chicken mansaf",
      "diet": "gf"
     },
     {
      "name": "Lamb mansaf",
      "diet": "gf"
     },
     {
      "name": "Persian jewelled rice",
      "diet": "gf"
     },
     {
      "name": "Saffron yellow rice",
      "diet": "gf vegan v"
     },
     {
      "name": "Vermicelli noodle rice",
      "diet": "vegan v"
     }
    ]
   },
   "afternoon": {
    "title": "Afternoon tea",
    "options": [
     {
      "name": "Gourmet muffins"
     },
     {
      "name": "Mini cannoli"
     },
     {
      "name": "Fruit salad cups",
      "diet": "vegan v"
     },
     {
      "name": "Knafeh cups"
     },
     {
      "name": "Brownies"
     }
    ]
   }
  },
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 48,
    "includes": "Morning tea: Mini pastries · Fresh fruit salad cups · Lunch: Gourmet sandwiches · Bread · Fresh salad · Seasonal fruit platter · Afternoon tea",
    "components": [
     {
      "name": "Morning tea: Mini pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 2
     },
     {
      "name": "Morning tea: Fresh fruit salad cups",
      "qty": "1 per person"
     },
     {
      "name": "Morning tea: Disposable serveware",
      "qty": "Included"
     },
     {
      "name": "Lunch: Gourmet sandwiches",
      "qty": "1.5 rounds per person",
      "set": "fillings",
      "choose": 3
     },
     {
      "name": "Lunch: Bread",
      "qty": "As selected",
      "set": "breads",
      "choose": 1,
      "chooseMax": 5
     },
     {
      "name": "Lunch: Fresh salad, large tray",
      "qty": "1 tray per 20 guests",
      "set": "salads",
      "choose": 1
     },
     {
      "name": "Lunch: Seasonal fruit platter",
      "qty": "1 per 20 guests"
     },
     {
      "name": "Afternoon tea",
      "qty": "1 sweet and 1 fruit cup per person",
      "set": "afternoon",
      "choose": 2
     }
    ],
    "variantId": 49073360273640
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 62,
    "includes": "Morning tea: Mini pastries · Gourmet muffins · Yoghurt granola cups · Fresh fruit salad cups · Lunch: Gourmet sandwiches · Bread · Fresh salads · Dips · Falafel with tahini · Seasonal fruit platter · Afternoon tea",
    "components": [
     {
      "name": "Morning tea: Mini pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 3
     },
     {
      "name": "Morning tea: Gourmet muffins",
      "qty": "1 per person"
     },
     {
      "name": "Morning tea: Yoghurt granola cups",
      "qty": "1 per 2 guests"
     },
     {
      "name": "Morning tea: Fresh fruit salad cups",
      "qty": "1 per person"
     },
     {
      "name": "Lunch: Gourmet sandwiches",
      "qty": "1.5 rounds per person",
      "set": "fillings",
      "choose": 3
     },
     {
      "name": "Lunch: Bread",
      "qty": "As selected",
      "set": "breads",
      "choose": 1,
      "chooseMax": 5
     },
     {
      "name": "Lunch: Fresh salads, large tray",
      "qty": "2 trays per 20 guests",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Lunch: Home made dips with Lebanese bread and pickles",
      "qty": "1 platter per 20 guests",
      "set": "dips",
      "choose": 3
     },
     {
      "name": "Lunch: Falafel with tahini",
      "qty": "2 pieces per person"
     },
     {
      "name": "Lunch: Seasonal fruit platter",
      "qty": "1 per 20 guests"
     },
     {
      "name": "Afternoon tea",
      "qty": "1 muffin and 1 dessert per person",
      "set": "afternoon",
      "choose": 3
     }
    ],
    "variantId": 49073360306408
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 78,
    "includes": "Morning tea: Mini pastries · Cakes and slices · Bites and cups · Savoury items · Lunch: Hot main · Rice · Fresh salads · Dips · Dessert selection · Afternoon tea",
    "components": [
     {
      "name": "Morning tea: Mini pastries",
      "qty": "2 per person",
      "set": "pastries",
      "choose": 3
     },
     {
      "name": "Morning tea: Cakes and slices",
      "qty": "1 per person",
      "set": "cakes",
      "choose": 2
     },
     {
      "name": "Morning tea: Bites and cups",
      "qty": "1 per person",
      "set": "bites",
      "choose": 2
     },
     {
      "name": "Morning tea: Savoury items",
      "qty": "1 per person",
      "set": "savoury",
      "choose": 2
     },
     {
      "name": "Lunch: Hot main, large tray",
      "qty": "1 tray per 15 guests",
      "set": "hotMains",
      "choose": 1
     },
     {
      "name": "Lunch: Rice, large tray",
      "qty": "1 tray per 18 guests",
      "set": "rice",
      "choose": 1
     },
     {
      "name": "Lunch: Fresh salads, large tray",
      "qty": "2 trays per 20 guests",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Lunch: Home made dips with Lebanese bread and pickles",
      "qty": "1 platter per 20 guests",
      "set": "dips",
      "choose": 3
     },
     {
      "name": "Lunch: Dessert selection",
      "qty": "1 piece per person",
      "set": "bites",
      "choose": 2
     },
     {
      "name": "Afternoon tea",
      "qty": "1 knafeh cup and 1 dessert per person",
      "set": "afternoon",
      "choose": 3
     }
    ],
    "variantId": 49073360339176
   }
  ],
  "slug": "full-day-meetings"
 },
 "individual-meals": {
  "name": "Individual Meals",
  "meta": [
   "Minimum 10 guests",
   "Drop off",
   "Individually packed, labelled and ready to hand out"
  ],
  "minGuests": 10,
  "minOrder": 300,
  "footnote": "Every box is labelled with the dish and its dietary markers, and can be labelled with guest names on request.",
  "sets": {
   "rolls": {
    "title": "Sandwiches, rolls and wraps",
    "note": "On panini, wraps, Lebanese flatbread or gluten free wrap",
    "options": [
     {
      "name": "BBQ chicken"
     },
     {
      "name": "Shawarma meat"
     },
     {
      "name": "Shawarma chicken"
     },
     {
      "name": "Kafta"
     },
     {
      "name": "Chicken schnitzel"
     },
     {
      "name": "Roasted vegetable",
      "diet": "v"
     },
     {
      "name": "Falafel",
      "diet": "v"
     },
     {
      "name": "Fried cauliflower",
      "diet": "v"
     },
     {
      "name": "Cold meats"
     }
    ]
   },
   "bowls": {
    "title": "Sammys bowls",
    "options": [
     {
      "name": "Shawarma chicken, saffron rice, fattoush, hommous, pickled turnip & garlic sauce"
     },
     {
      "name": "Shawarma meat, vermicelli rice, tabouli, hommous & tahini"
     },
     {
      "name": "Chicken tawook, saffron rice, rainbow slaw, toum & pickles"
     },
     {
      "name": "Kafta, Persian jewelled rice, Greek salad & baba ghanouj"
     },
     {
      "name": "Falafel & halloumi, mjadra, tabouli, hommous & tahini",
      "diet": "v"
     },
     {
      "name": "Roasted vegetable & halloumi, saffron rice, fattoush & hommous",
      "diet": "v"
     },
     {
      "name": "Mezza bowl, hommous, baba ghanouj, labneh, falafel, vine leaves, tabouli & fried bread",
      "diet": "v"
     },
     {
      "name": "Garlic prawn, saffron rice & fattoush",
      "sub": "Premium"
     }
    ]
   },
   "salads": {
    "title": "Side salads",
    "options": [
     { "name": "Tabouli", "diet": "vegan v" },
     { "name": "Fattoush", "diet": "vegan v" },
     { "name": "Greek", "diet": "v" },
     { "name": "Rainbow cabbage slaw", "diet": "v" },
     { "name": "Roasted pumpkin, pear & walnut", "diet": "v" }
    ]
   },
   "sweets": {
    "title": "Sweets",
    "options": [
     { "name": "Fruit salad cup", "diet": "vegan v" },
     { "name": "Mini cannoli" },
     { "name": "Chocolate hedgehog" },
     { "name": "Brownie" },
     { "name": "Friand", "diet": "gf" }
    ]
   },
   "bowlsOrSandwiches": {
    "title": "Sammys bowls and gourmet sandwiches",
    "note": "Sandwiches come on panini, wraps, Lebanese flatbread or a gluten free wrap",
    "options": [
     { "name": "Bowl: Shawarma chicken, saffron rice, fattoush, hommous, pickled turnip & garlic sauce" },
     { "name": "Bowl: Shawarma meat, vermicelli rice, tabouli, hommous & tahini" },
     { "name": "Bowl: Chicken tawook, saffron rice, rainbow slaw, toum & pickles" },
     { "name": "Bowl: Kafta, Persian jewelled rice, Greek salad & baba ghanouj" },
     { "name": "Bowl: Falafel & halloumi, mjadra, tabouli, hommous & tahini", "diet": "v" },
     { "name": "Bowl: Roasted vegetable & halloumi, saffron rice, fattoush & hommous", "diet": "v" },
     { "name": "Bowl: Mezza bowl, hommous, baba ghanouj, labneh, falafel, vine leaves, tabouli & fried bread", "diet": "v" },
     { "name": "Gourmet sandwich: BBQ chicken" },
     { "name": "Gourmet sandwich: Shawarma meat" },
     { "name": "Gourmet sandwich: Shawarma chicken" },
     { "name": "Gourmet sandwich: Kafta" },
     { "name": "Gourmet sandwich: Chicken schnitzel" },
     { "name": "Gourmet sandwich: Roasted vegetable", "diet": "v" },
     { "name": "Gourmet sandwich: Falafel", "diet": "v" },
     { "name": "Gourmet sandwich: Fried cauliflower", "diet": "v" },
     { "name": "Gourmet sandwich: Cold meats" }
    ]
   },
   "dips": {
    "title": "Dips",
    "options": [
     {
      "name": "Hommous",
      "diet": "vegan v"
     },
     {
      "name": "Baba ghanouj",
      "diet": "vegan v"
     },
     {
      "name": "Labneh",
      "diet": "v"
     },
     {
      "name": "Garlic",
      "diet": "vegan v"
     },
     {
      "name": "Shangleesh",
      "diet": "v"
     },
     {
      "name": "Avocado & garlic",
      "diet": "vegan v"
     }
    ]
   }
  },
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 18,
    "includes": "Filled roll, wrap or panini · Piece of seasonal fruit",
    "components": [
     {
      "name": "Filled roll, wrap or panini",
      "qty": "1 per person",
      "set": "rolls",
      "choose": 3,
      "allocate": true
     },
     {
      "name": "Piece of seasonal fruit",
      "qty": "1 per person"
     },
     {
      "name": "Box, label and cutlery",
      "qty": "1 per person"
     }
    ],
    "variantId": 49073360404712
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 24,
    "includes": "Sammys bowl or gourmet sandwich · Side salad · Something sweet",
    "components": [
     {
      "name": "Sammys bowl or gourmet sandwich",
      "qty": "1 per person",
      "set": "bowlsOrSandwiches",
      "choose": 3,
      "allocate": true
     },
     {
      "name": "Side salad",
      "qty": "1 portion per person",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Something sweet",
      "qty": "1 per person",
      "set": "sweets",
      "choose": 2
     },
     {
      "name": "Box, label and cutlery",
      "qty": "1 per person"
     }
    ],
    "variantId": 49073360437480
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 32,
    "includes": "Premium Sammys bowl · Dips and bread · Side salad · Dessert · Individual drink",
    "components": [
     {
      "name": "Premium Sammys bowl",
      "qty": "1 per person",
      "set": "bowls",
      "choose": 3,
      "allocate": true
     },
     {
      "name": "Dips and bread",
      "qty": "1 portion per person",
      "set": "dips",
      "choose": 2
     },
     {
      "name": "Side salad",
      "qty": "1 portion per person",
      "set": "salads",
      "choose": 2
     },
     {
      "name": "Dessert",
      "qty": "1 per person",
      "set": "sweets",
      "choose": 2
     },
     {
      "name": "Individual drink",
      "qty": "1 per person"
     },
     {
      "name": "Box, label and cutlery",
      "qty": "1 per person"
     }
    ],
    "variantId": 49073360470248
   }
  ],
  "slug": "individual-meals"
 },
 "celebrations-events": {
  "slug": "celebrations-events",
  "name": "Celebrations & Events",
  "meta": [
   "Minimum 40 guests",
   "Staffed or drop off",
   "Canapés, grazing and stations"
  ],
  "minGuests": 40,
  "minOrder": 300,
  "footnote": "Service staff, styling and set-up available on request.",
  "sets": {},
  "tiers": [
   {
    "id": "mezza",
    "name": "Mezza",
    "tag": "The Essentials",
    "price": 38,
    "includes": "Canapé selection · Small grazing table",
    "components": [
     {
      "name": "Canapé selection",
      "qty": "6 pieces per person"
     },
     {
      "name": "Small grazing table",
      "qty": "Serves the room"
     },
     {
      "name": "Disposable serveware",
      "qty": "Included"
     }
    ],
    "variantId": 49073360601320
   },
   {
    "id": "ahla",
    "name": "Ahla",
    "tag": "The Signature",
    "price": 55,
    "includes": "Everything in Mezza · Full buffet spread · Celebration station",
    "components": [
     {
      "group": "Full Mezza package included"
     },
     {
      "name": "Canapé selection",
      "qty": "6 pieces per person"
     },
     {
      "name": "Small grazing table",
      "qty": "Serves the room"
     },
     {
      "group": "Plus"
     },
     {
      "name": "Full buffet spread",
      "qty": "1 per person"
     },
     {
      "name": "Celebration station",
      "qty": "1 station"
     }
    ],
    "variantId": 49073360634088
   },
   {
    "id": "sahtein",
    "name": "Sahtein",
    "tag": "The Feast",
    "price": 78,
    "includes": "Everything in Ahla · Chef-attended stations · Full event styling & staff",
    "components": [
     {
      "group": "Full Ahla package included"
     },
     {
      "name": "Full buffet spread",
      "qty": "1 per person"
     },
     {
      "name": "Celebration station",
      "qty": "1 station"
     },
     {
      "group": "Plus"
     },
     {
      "name": "Chef-attended stations",
      "qty": "On request"
     },
     {
      "name": "Full event styling & staff",
      "qty": "On request"
     }
    ],
    "variantId": 49073360666856
   }
  ]
 }
};


/* ===========================================================================
   Event & celebration packages.

   Transcribed from the client's "Package breakdowns" PDF, which is the
   authoritative source: pp.20-21 canapes, pp.22-24 buffets, pp.26-29 grazing
   tables, pp.30-32 celebration stations. Where the Website & User Flow
   document disagrees with the PDF, the PDF wins; the differences are noted
   against each package.

   Appended rather than folded into the literal above so the drop-off packages
   stay byte-identical to what the client already signed off.
   =========================================================================== */

/* Shared option lists. The PDF repeats these verbatim across packages, so they
   are written once and referenced, which keeps them from drifting apart. */
var SAMMYS_SALADS = [
  { name: 'Tabouli', diet: 'vegan v' },
  { name: 'Fattoush', diet: 'vegan v gf' },
  { name: 'Greek', diet: 'v' },
  { name: 'Rainbow cabbage slaw', diet: 'v' },
  { name: 'Roasted pumpkin, pear & walnut', diet: 'v' },
  { name: 'Falafel & halloumi', diet: 'v' },
  { name: 'Potato', diet: 'v' },
  { name: 'Pasta', diet: 'v' },
  { name: 'Caesar' },
  { name: 'Seafood' }
];

var SAMMYS_DIPS_MEZZA = [
  { name: 'Hommous', diet: 'vegan v' },
  { name: 'Baba ghanouj', diet: 'vegan v' },
  { name: 'Labneh', diet: 'v' },
  { name: 'Garlic', diet: 'vegan v' },
  { name: 'Shangleesh', diet: 'v' },
  { name: 'Avocado & garlic', diet: 'vegan v' },
  { name: 'Falafel', diet: 'vegan v' },
  { name: 'Kibbeh' },
  { name: 'Sombosik' },
  { name: 'Lady fingers' },
  { name: 'Vine leaves', diet: 'vegan v gf' },
  { name: 'Fried cauliflower', diet: 'vegan v' }
];

var SAMMYS_STATIONS = [
  { name: 'Kebab Station' },
  { name: 'Slider Station' },
  { name: 'Tacos or rice plates' },
  { name: 'Onsite Lebanese BBQ' },
  { name: 'Potato Spud Station' },
  { name: 'Lebanese breakfast' },
  { name: 'Pasta' },
  { name: 'Salad bar' },
  { name: 'Antipasto cart' },
  { name: 'Nachos' },
  { name: 'Stirfry' },
  { name: 'Dubai Wrap Station' }
];

var SAMMYS_BUFFET_MAINS = [
  { name: 'Chicken lemon garlic' },
  { name: 'Kafta & potato' },
  { name: 'Shish barrak' },
  { name: 'Cabbage rolls', diet: 'gf' },
  { name: 'Loubiyeh, meat or vegan', diet: 'gf' },
  { name: 'Stuffed zucchini', diet: 'gf' },
  { name: 'Beef lasagne' },
  { name: 'Meat vine leaves' },
  { name: 'Roasted vegetable pesto pasta', diet: 'v' },
  { name: 'Chicken mushroom tortellini' }
];

var SAMMYS_RICE = [
  { name: 'Chicken mansaf', diet: 'gf' },
  { name: 'Lamb mansaf', diet: 'gf' },
  { name: 'Persian jewelled rice', diet: 'gf' },
  { name: 'Saffron yellow rice', diet: 'vegan v gf' },
  { name: 'Vermicelli noodle rice', diet: 'vegan v' }
];

var SAMMYS_BUFFET_DIPS = [
  { name: 'Hommous', diet: 'vegan v' },
  { name: 'Baba ghanouj', diet: 'vegan v' },
  { name: 'Labneh', diet: 'v' },
  { name: 'Garlic', diet: 'vegan v' },
  { name: 'Shangleesh', diet: 'v' },
  { name: 'Labneh, garlic & mint', diet: 'v' },
  { name: 'Avocado & garlic', diet: 'vegan v' }
];

/* ---------------------------------------------------------------------------
   Celebration Stations - PDF pp.30-32. Minimum 50 guests.

   Station first, then tier: the station is what the guest is really choosing,
   and the tier prices it. Sahtein takes two stations, modelled as the lead
   pick plus one more that excludes it.

   Differs from the flow document, which named the stations differently
   ("Lebanese BBQ", "Dubai Wraps", ...) and listed only 7 salads. The PDF's own
   names and its 10 salads are used here.
   --------------------------------------------------------------------------- */
window.SAMMYS_MENUS['live-catering'] = {
  styling: {
    question: 'Would you like styling and set up on the night?',
    note: 'Set up $350, pack down and cleaning $250. Added as their own lines, so you can drop them at the cart.',
    setup: 350,
    packdown: 250,
    setupVariantId: 50753539047656,
    packdownVariantId: 50753539080424
  },
  name: 'Celebration Stations',
  meta: ['Minimum 50 guests', 'Service staff included', 'Birthdays, engagements and family celebrations'],
  minGuests: 50,
  minOrder: 0,
  footnote: 'All stations fully customisable to your theme. Styling and set up from $350, pack down from $250.',

  lead: {
    name: 'Live cooking station',
    set: 'stations',
    rule: 'Choose the station that anchors your event',
    note: 'Pick the station first. The tier then sets the price, the salads, and whether a second station and a dessert cart come with it.'
  },

  sets: {
    stations: { title: 'Live cooking stations', options: SAMMYS_STATIONS },
    salads: { title: 'Salads', options: SAMMYS_SALADS },
    grazing: { title: 'Dips & mezza', options: SAMMYS_DIPS_MEZZA },
    desserts: {
      title: 'Dessert stations',
      options: [
        { name: 'Knafeh' },
        { name: 'Donut stuffing' },
        { name: 'Live gelato cart' },
        { name: 'Live acai cart' },
        { name: 'Live cannoli piping' },
        { name: 'Dubai strawberry cups' },
        { name: 'Waffle' },
        { name: 'Dutch pancake' },
        { name: 'Tiramisu' }
      ]
    }
  },

  tiers: [
    {
      id: 'mezza',
      variantId: 50753538851048,
      name: 'Mezza',
      tag: 'The Essentials',
      price: 55,
      includes: 'Live cooking station · Salads and sides',
      components: [
        { name: 'Live cooking station', qty: '1 station' },
        { name: 'Salads and sides', qty: '2 varieties', set: 'salads', choose: 2 },
        { name: 'Service staff', qty: 'Included' }
      ]
    },
    {
      id: 'ahla',
      variantId: 50753541210344,
      name: 'Ahla',
      tag: 'The Signature',
      price: 72,
      includes: 'Live cooking station · Mezza grazing table on arrival · Salads and sides',
      components: [
        { name: 'Live cooking station', qty: '1 station' },
        { group: 'Plus a mezza grazing table on arrival' },
        { name: 'Mezza grazing table on arrival', qty: 'Serves up to 20 guests', set: 'grazing', choose: 8 },
        { name: 'Salads and sides', qty: '2 varieties', set: 'salads', choose: 2 },
        { name: 'Service staff', qty: 'Included' }
      ]
    },
    {
      id: 'sahtein',
      variantId: 50753541243112,
      name: 'Sahtein',
      tag: 'The Feast',
      price: 90,
      includes: 'Two live cooking stations · Dessert station · Salads and sides',
      components: [
        { name: 'Live cooking station', qty: '1 station' },
        { group: 'Plus a second station and a dessert cart' },
        /* excludeLead is what stops the second station repeating the first. */
        { name: 'Second live cooking station', qty: '1 station', set: 'stations', choose: 1, excludeLead: true },
        { name: 'Dessert station', qty: '1 station', set: 'desserts', choose: 1 },
        { name: 'Salads and sides', qty: '3 varieties', set: 'salads', choose: 3 },
        { name: 'Service staff', qty: 'Included' }
      ]
    }
  ]
};

/* ---------------------------------------------------------------------------
   Canapes - PDF pp.20-21. Minimum 40 guests.
   --------------------------------------------------------------------------- */
window.SAMMYS_MENUS['canapes'] = {
  styling: {
    question: 'Would you like styling and set up on the night?',
    note: 'Set up $350, pack down and cleaning $250. Added as their own lines, so you can drop them at the cart.',
    setup: 350,
    packdown: 250,
    setupVariantId: 50753539047656,
    packdownVariantId: 50753539080424
  },
  name: 'Canapés',
  meta: ['Minimum 40 guests', 'Service staff included', 'Client functions, launches and evening events'],
  minGuests: 40,
  minOrder: 1500,
  footnote: 'Styling and set up from $350, pack down and cleaning from $250.',

  sets: {
    fingerFood: {
      title: 'Finger food & mezze',
      options: [
        { name: 'Arancini balls', sub: 'V or meat', diet: 'v' },
        { name: 'Mini burgers' },
        { name: 'Falafel', diet: 'vegan v gf' },
        { name: 'Vine leaves', diet: 'vegan v gf' },
        { name: 'Lady fingers' },
        { name: 'Cocktail skewers' },
        { name: 'Mini meat pies' },
        { name: 'Vegetarian spring rolls', diet: 'v' },
        { name: 'Sombosik' },
        { name: 'Kibbeh' },
        { name: 'Mini hotdogs' },
        { name: 'Mini pizzas' },
        { name: 'Bruschetta cups' },
        { name: 'Honey halloumi spring rolls' },
        { name: 'BBQ chicken skewers', diet: 'gf' },
        { name: 'Vegetarian rice paper rolls', diet: 'vegan v gf' },
        { name: 'Cherry tomato and bocconcini skewers', diet: 'v gf' }
      ]
    },
    substantial: {
      title: 'Subs & tacos',
      options: [
        { name: 'Kafta subs' },
        { name: 'Crispy chicken subs' },
        { name: 'Fish tacos', sub: 'GF available' },
        { name: 'Crispy chicken tacos', sub: 'GF available' }
      ]
    },
    premium: {
      title: 'Premium & dessert',
      options: [
        { name: 'Individual antipasto cups' },
        { name: 'Prosciutto & bocconcini skewers' },
        { name: 'Mini cannoli' },
        { name: 'Knafeh cups' },
        { name: 'Mini cheesecakes' }
      ]
    }
  },

  tiers: [
    {
      id: 'mezza',
      variantId: 50753538949352,
      name: 'Mezza',
      tag: 'The Essentials',
      price: 38,
      includes: 'Canapés, 6 pieces per person',
      components: [
        { name: 'Canapés', qty: '6 pieces per person', set: 'fingerFood', choose: 5 },
        { name: 'Service staff', qty: 'Included' }
      ]
    },
    {
      id: 'ahla',
      variantId: 50753541275880,
      name: 'Ahla',
      tag: 'The Signature',
      price: 48,
      includes: 'Canapés, 7 pieces per person · Subs & tacos',
      components: [
        { name: 'Canapés', qty: '7 pieces per person', set: 'fingerFood', choose: 6 },
        { name: 'Subs & tacos', qty: '1 piece per person', set: 'substantial', choose: 1 },
        { name: 'Service staff', qty: 'Included' }
      ]
    },
    {
      id: 'sahtein',
      variantId: 50753541308648,
      name: 'Sahtein',
      tag: 'The Feast',
      price: 58,
      includes: 'Canapés, 8 pieces per person · Premium and dessert selections',
      components: [
        { name: 'Canapés', qty: '8 pieces per person', set: 'fingerFood', choose: 7 },
        { name: 'Premium and dessert selections', qty: '2 pieces per person', set: 'premium', choose: 2 },
        { name: 'Service staff', qty: 'Included' }
      ]
    }
  ]
};

/* ---------------------------------------------------------------------------
   Buffets - PDF pp.22-24. Minimum 30 guests.

   The flow document called this "Award Nights / End of Year" at $68/$88/$110
   with a 50-guest minimum. The PDF prices it $48/$58/$72 from 30 guests, so
   those are used. Worth confirming with the client which is current.
   --------------------------------------------------------------------------- */
window.SAMMYS_MENUS['buffets'] = {
  styling: {
    question: 'Would you like styling and set up on the night?',
    note: 'Set up $350, pack down and cleaning $250. Added as their own lines, so you can drop them at the cart.',
    setup: 350,
    packdown: 250,
    setupVariantId: 50753539047656,
    packdownVariantId: 50753539080424
  },
  name: 'Buffets',
  meta: ['Minimum 30 guests', 'Drop off', 'The full Lebanese table, laid out and ready to share'],
  minGuests: 30,
  minOrder: 1500,
  footnote: 'Award nights, galas and end of year functions. More mains available on request.',

  sets: {
    mains: { title: 'Mains', note: 'And more on request', options: SAMMYS_BUFFET_MAINS },
    rice: { title: 'Rice', options: SAMMYS_RICE },
    salads: { title: 'Salads', options: SAMMYS_SALADS },
    dips: { title: 'Dips', options: SAMMYS_BUFFET_DIPS },
    premiumMains: {
      title: 'Premium mains',
      options: [
        { name: 'Lamb roast with vegetables' },
        { name: 'Creamy garlic prawns with rice' },
        { name: 'Prawn & vegetables' },
        { name: 'Charcoal chicken', diet: 'gf' },
        { name: 'Chicken breast in creamy mushroom sauce', diet: 'gf' }
      ]
    },
    bites: {
      title: 'Bites & cups',
      options: [
        { name: 'Mini cannoli' },
        { name: 'Knafeh cups' },
        { name: 'Rice pudding cups' },
        { name: 'Fruit custard tarts' },
        { name: 'Mini cheesecakes' },
        { name: 'Mini eclairs' },
        { name: 'Katayfi fingers' },
        { name: 'Chocolate sombosik' }
      ]
    }
  },

  tiers: [
    {
      id: 'mezza',
      variantId: 50753538982120,
      name: 'Mezza',
      tag: 'The Essentials',
      price: 48,
      includes: 'Mains · Rice · Salads · Home made dips · Lebanese bread, fried bread and pickles',
      components: [
        { name: 'Mains, large tray', qty: '2 trays per 30 guests', set: 'mains', choose: 2 },
        { name: 'Rice, large tray', qty: '1 tray per 18 guests', set: 'rice', choose: 1 },
        { name: 'Salads, large tray', qty: '2 trays per 30 guests', set: 'salads', choose: 2 },
        { name: 'Home made dips, large platter', qty: '1 platter per 25 guests', set: 'dips', choose: 4 },
        { name: 'Lebanese bread, fried bread and pickles', qty: 'Included' }
      ]
    },
    {
      id: 'ahla',
      variantId: 50753541341416,
      name: 'Ahla',
      tag: 'The Signature',
      price: 58,
      includes: 'Mains · Charcoal chicken · Rice · Salads · Home made dips · Lebanese bread, fried bread and pickles',
      components: [
        { name: 'Mains, large tray', qty: '2 trays per 30 guests', set: 'mains', choose: 2 },
        { name: 'Charcoal chicken', qty: '1 per 4 guests' },
        { name: 'Rice, large tray', qty: '2 trays per 30 guests', set: 'rice', choose: 2 },
        { name: 'Salads, large tray', qty: '3 trays per 30 guests', set: 'salads', choose: 3 },
        { name: 'Home made dips, large platter', qty: '1 platter per 25 guests', set: 'dips', choose: 4 },
        { name: 'Lebanese bread, fried bread and pickles', qty: 'Included' }
      ]
    },
    {
      id: 'sahtein',
      variantId: 50753541374184,
      name: 'Sahtein',
      tag: 'The Feast',
      price: 72,
      includes: 'Full Ahla Package Included · Premium main · Dessert selection',
      components: [
        { group: 'Full Ahla package included' },
        { name: 'Mains, large tray', qty: '2 trays per 30 guests', set: 'mains', choose: 2 },
        { name: 'Charcoal chicken', qty: '1 per 4 guests' },
        { name: 'Rice, large tray', qty: '2 trays per 30 guests', set: 'rice', choose: 2 },
        { name: 'Salads, large tray', qty: '3 trays per 30 guests', set: 'salads', choose: 3 },
        { name: 'Home made dips, large platter', qty: '1 platter per 25 guests', set: 'dips', choose: 4 },
        { name: 'Lebanese bread, fried bread and pickles', qty: 'Included' },
        { group: 'Plus' },
        { name: 'Premium main, large tray', qty: '1 tray per 30 guests', set: 'premiumMains', choose: 1 },
        { name: 'Dessert selection', qty: '1 piece per person', set: 'bites', choose: 2 }
      ]
    }
  ]
};

/* ---------------------------------------------------------------------------
   Grazing Tables - PDF pp.26-29.

   Priced per table, not per person, so priceUnit switches the builder's maths
   and its summary wording. Guest capacity is a property of the tier rather
   than something the customer enters.
   --------------------------------------------------------------------------- */
window.SAMMYS_MENUS['grazing-tables'] = {
  styling: {
    question: 'Would you like this styled and set up on site?',
    note: 'Set up $350, pack down and cleaning $250. Added as their own lines, so you can drop them at the cart.',
    setup: 350,
    packdown: 250,
    setupVariantId: 50753539047656,
    packdownVariantId: 50753539080424
  },
  name: 'Grazing Tables',
  meta: ['Priced per table', 'Fully styled and set up on site', 'Refundable bond applies to platters and props'],
  minGuests: 0,
  minOrder: 1500,
  priceUnit: 'table',
  footnote: 'Larger guest numbers quoted on request. Vegetarian, Halal and gluten free tables available. A refundable bond applies to platters and props, returned clean and unbroken within 3 days.',

  sets: {
    grazing: { title: 'Dips & mezza', options: SAMMYS_DIPS_MEZZA },
    dessertCorner: {
      title: 'Dessert corner',
      options: [
        { name: 'Mini cannoli' },
        { name: 'Chocolate hedgehog' },
        { name: 'Mini cheesecakes' },
        { name: 'Knafeh cups' },
        { name: 'Fruit custard tarts' }
      ]
    }
  },

  tiers: [
    {
      id: 'mezza',
      capacity: 20,
      variantId: 50753539014888,
      name: 'Mezza',
      tag: 'The Essentials',
      price: 600,
      includes: 'Serves up to 20 guests · 8 dip and mezza varieties · Styled on site',
      components: [
        { name: 'Serves', qty: 'Up to 20 guests' },
        { name: 'Dips and mezza', qty: '8 varieties', set: 'grazing', choose: 8 },
        { name: 'Breads, pickles and condiments', qty: 'Included' },
        { name: 'Styling with platters, risers and plinths', qty: 'Included' }
      ]
    },
    {
      id: 'ahla',
      capacity: 40,
      variantId: 50753541406952,
      name: 'Ahla',
      tag: 'The Signature',
      price: 1000,
      includes: 'Serves up to 40 guests · 10 varieties · Full antipasto · Styled on site',
      components: [
        { name: 'Serves', qty: 'Up to 40 guests' },
        { name: 'Dips and mezza', qty: '10 varieties', set: 'grazing', choose: 10 },
        { name: 'Antipasto', qty: 'Full selection' },
        { name: 'Breads, pickles and condiments', qty: 'Included' },
        { name: 'Styling with platters, risers and plinths', qty: 'Included' }
      ]
    },
    {
      id: 'sahtein',
      capacity: 60,
      variantId: 50753541439720,
      name: 'Sahtein',
      tag: 'The Feast',
      price: 1600,
      includes: 'Serves up to 60 guests · 10 varieties · Antipasto · Hot finger food · Dessert corner',
      components: [
        { group: 'Full Ahla package included' },
        { name: 'Serves', qty: 'Up to 60 guests' },
        { name: 'Dips and mezza', qty: '10 varieties', set: 'grazing', choose: 10 },
        { name: 'Antipasto', qty: 'Full selection' },
        { name: 'Breads, pickles and condiments', qty: 'Included' },
        { name: 'Styling with platters, risers and plinths', qty: 'Included' },
        { group: 'Plus' },
        { name: 'Hot finger food additions', qty: '3 varieties', set: 'grazing', choose: 3 },
        { name: 'Dessert corner', qty: '3 varieties', set: 'dessertCorner', choose: 3 },
        { name: 'Full plinth and riser display', qty: 'Included, floral on request' }
      ]
    }
  ]
};

/* ---------------------------------------------------------------------------
   Event add ons - the "Add ons for any package" list on the event catering
   page, offered as an optional step in the event builders.

   per: 'person' follows the headcount; anything else takes a count. Each
   variantId is a product of its own ("Sammy's Events Add-on - ...") so the
   extra charges at checkout. Entries without one link out instead.
   --------------------------------------------------------------------------- */
var SAMMYS_EVENT_ADDONS = [
  { name: 'Canapés on arrival', detail: '3 pieces per person, finger food and mezze', price: 12, per: 'person', variantId: 67732283097320 },
  { name: 'Drinks package', detail: 'Juice dispensers and flutes of flavoured juice or sunrise mocktail', price: 9, per: 'person', variantId: 67732283523304 },
  { name: 'Dessert platter', detail: 'Mini cannoli, brownies and chocolate hedgehog slices', price: 8, per: 'person', variantId: 67732283883752 },
  { name: 'Dessert station, live', detail: 'Knafeh, donut stuffing or cannoli piping', price: 12, per: 'person', minGuests: 50, variantId: 67732284276968 },
  { name: 'Late night snack', detail: 'Sliders or kafta subs, served late', price: 10, per: 'person', variantId: 67732284637416 },
  { name: 'Kids table', detail: 'Veg, fruit, dips, crackers and a sweets platter', price: 120, per: 'table', variantId: 67732285030632 },
  { name: 'Hot chips', detail: 'Added to any station or buffet', price: 4, per: 'person', variantId: 67732293550312 },
  { name: 'Grazing table on arrival', detail: 'A styled dips and mezza welcome table', priceLabel: 'from $600', link: '/pages/grazing-tables', linkLabel: 'Build a table' },
  { name: 'Styling extras', detail: 'Floral, tableware, linen and theming', priceLabel: 'On request', link: '/pages/event-catering#enquiry', linkLabel: 'Ask us' }
];

window.SAMMYS_MENUS['canapes'].addons = SAMMYS_EVENT_ADDONS;
window.SAMMYS_MENUS['buffets'].addons = SAMMYS_EVENT_ADDONS;
window.SAMMYS_MENUS['live-catering'].addons = SAMMYS_EVENT_ADDONS;
/* A grazing table does not need a grazing table on arrival. */
window.SAMMYS_MENUS['grazing-tables'].addons = SAMMYS_EVENT_ADDONS.filter(function (a) { return a.link !== '/pages/grazing-tables'; });

/* ---------------------------------------------------------------------------
   Services - a package reused with its own fees and floor, switched on by
   ?service=<key> in the page address.

   Board room & office: the drop off menu, brought in and set up on site.
   Set up reuses the events set up fee product ($350); pack down is its own
   product at $280, since the events pack down is $250.
   --------------------------------------------------------------------------- */
window.SAMMYS_SERVICES = {
  boardroom: {
    name: 'Board room & office',
    packages: ['corporate-breakfast', 'morning-afternoon-tea', 'working-lunch', 'full-day-meetings', 'individual-meals'],
    note: 'Board room & office service: we bring the drop off menu in and set it up properly. Set up ($350) and pack down ($280) are added at checkout, and the order minimum is $1,500.',
    minOrder: 1500,
    backLabel: 'Board room & office',
    backLink: '/pages/boardroom-office-catering',
    fees: [
      { name: 'Set up', price: 350, variantId: 50753539047656 },
      { name: 'Pack down', price: 280, variantId: 67732282736872 }
    ]
  }
};
